/*
 * Copyright 2026 Hypergiant Galactic Systems Inc. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import { clsx } from '@accelint/design-foundation/lib/utils';
import { Text, type TextProps } from 'react-aria-components/Text';
import styles from './styles.module.css';

/**
 * TreeItemLabel - Primary text label for a tree item
 *
 * @example
 * ```tsx
 * <TreeItemContent>
 *   <TreeItemLabel>Documents</TreeItemLabel>
 *   <TreeItemDescription>Folder</TreeItemDescription>
 * </TreeItemContent>
 * ```
 *
 * @param props - TextProps from react-aria-components.
 * @param props.children - Label text content.
 * @param props.className - CSS class for the label.
 * @returns The rendered TreeItemLabel component.
 */
export function TreeItemLabel({ children, className }: TextProps) {
  return <Text className={clsx(styles.label, className)}>{children}</Text>;
}
